import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Page, PageMetadata, PaginationFilter } from '@tran-monorepo/interfaces';
import { AwardCommitteeMeeting } from '@tran-monorepo/interfaces/applications';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AwardCommitteeMeetingsService {
    private readonly http = inject(HttpClient);

    private readonly apiUrl = `${environment.apiUrl}/v1/award-committee-meetings`;

    public getMeetings(
        query: PaginationFilter,
        startDate: string
    ): Observable<Page<AwardCommitteeMeeting, PageMetadata>> {
        const params = new HttpParams({ fromObject: { ...query, startDate } });

        return this.http.get<Page<AwardCommitteeMeeting, PageMetadata>>(`${this.apiUrl}`, { params });
    }
}
